import { create } from 'zustand';

export const useLegalReasonStore = create((set) => ({
  // State
  reasons: [],
  selectedReason: null,
  loading: false,
  error: null,
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  columnFilters: {},
  uniqueValues: {},
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  reasonToDelete: null,

  // Pure State Setters
  setReasons: (reasons) => set({ reasons }),
  setSelectedReason: (selectedReason) => set({ selectedReason }),
  setPaginationData: (paginationData) => set({ paginationData }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // Form actions
  openForm: () => set({ isFormOpen: true, isEditMode: false, selectedReason: null }),
  openEditForm: (reason) => set({ isFormOpen: true, isEditMode: true, selectedReason: reason }),
  closeForm: () => set({ isFormOpen: false, isEditMode: false, selectedReason: null }),

  // Delete dialog actions
  openDeleteDialog: (reason) => set({ isDeleteDialogOpen: true, reasonToDelete: reason }),
  closeDeleteDialog: () => set({ isDeleteDialogOpen: false, reasonToDelete: null }),

}));

export default useLegalReasonStore;
